import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { 
	selectResult, 
	setFilter, 
	selectFilterState 
} from '../oilSearchSlice'
import OilFilter from 'components/filters/OilFilter/OilFilter'

const OilSearchFilter = () => {
	const result = useSelector(selectResult)
	const dispatch = useDispatch()
	const filterState = useSelector(selectFilterState)

	const handleFilterChange = (articleIds, filterState) => {
		dispatch(setFilter({ articleIds, filterState }))
	}

	return (
		<div className="OilSearchFilter">
			{
				result &&
				<OilFilter 
					result={result} 
					filterState={filterState}
					onFilterChange={handleFilterChange} />
			}
		</div>
	)
}

export default OilSearchFilter